import { VStack } from '@cad-arc';
import { useDispatchAreaStore } from '../../../dispatch-areas/use-dispatch-areas';
import { FormSelect } from '../../../forms/integrated-form-controls/form-select';
import { FormUnitSelect } from '../../../forms/integrated-form-controls/form-unit-select';
import { FormUserSelect } from '../../../forms/integrated-form-controls/form-user-select';
import { useIntegratedForm } from '../../../forms/use-integrated-form';
import { timeRangeOptions } from '../../constants';
import { UnitHistoryForm } from '../../types';
import { useUnitHistoryFormEditEffects } from '../../hooks/use-unit-history-form-edit-effects';
import { useApplicationType } from '../../../common/hooks/use-application-type';
import { FormDateRange } from '../../../forms/integrated-form-controls/form-date-range';
import { observer } from 'mobx-react-lite';

export const UnitHistorySearchForm = observer(function UnitHistorySearchForm(): React.ReactElement {
    const { form } = useIntegratedForm<UnitHistoryForm>();
    const { isFirstResponder } = useApplicationType();

    const dispatchAreaIds = useDispatchAreaStore().monitoredAndOwnedDispatchAreaIds;

    const { showDateRangeInput } = useUnitHistoryFormEditEffects();

    return (
        <VStack
            align="left"
            gap="12px"
            padding="0 16px"
            {...(isFirstResponder ? {} : { bgColor: 'surface.foreground' })}
        >
            <FormUnitSelect
                label="Unit"
                name="unitOption"
                control={form.control}
                unitSelectProps={{
                    dispatchAreaIds,
                    showSelectedGroup: false,
                }}
                autoFocus={true}
            />
            {!isFirstResponder && (
                <FormUserSelect
                    label="Personnel"
                    name="userOption"
                    control={form.control}
                    userSelectProps={{ defaultValue: null }}
                />
            )}
            <FormSelect
                label="Time Range"
                name="timeRangeOption"
                control={form.control}
                options={timeRangeOptions}
                selectProps={{ isClearable: false }}
            />
            {showDateRangeInput && (
                <FormDateRange
                    name="dateRange"
                    control={form.control}
                    dateRangeProps={{
                        hasCalendar: true,
                        isStacked: true,
                        startFormControlProps: { label: 'From' },
                        endFormControlProps: { label: 'To' },
                        granularity: 'minute',
                        hideTimeZone: true,
                        hourCycle: 24,
                    }}
                />
            )}
        </VStack>
    );
});
